export enum ResetPasswordSources {
	DASHBOARD = 'dashboard',
	GUEST_REVIEW = 'guest-review'
}
